<template>
  <div class="contentbox">
    <!--新增客戶公司-->
    <mt-popup
      v-model="show_add_box"
      :modal="true"
      class="add_subsidiaries_box"
      position="content">
      <slot>
        <div class="signature_box">
          <div class="itme_box">
            <div class="itme">
              <div class="name">客戶類型</div>
              <el-select
                v-model="add_Client_company.customer_num_main"
                @change="change_customer_num_main"
                class="right20"
                placeholder="客戶類型第一層">
                <el-option
                  v-for="item in customer_type"
                  :key="item.category_remark"
                  :label="item.category_name"
                  :value="item.category_remark">
                </el-option>
              </el-select>
              <el-select
                v-model="add_Client_company.customer_num_secondary"
                class="right20"
                @change="change_customer_num_secondary" placeholder="客戶類型第二層">
                <el-option
                  v-for="item in customer_type2"
                  :key="item.category_remark"
                  :label="item.category_name"
                  :value="item.category_remark">
                </el-option>
              </el-select>
              <!--<el-input class="customer_num" v-model="add_Client_company.customer_num"></el-input>-->
            </div>
            <div class="itme">
              <div class="name">客戶公司名稱</div>
              <el-input v-model="add_Client_company.company"></el-input>
            </div>
            <div class="itme">
              <div class="name">地區</div>
              <el-select
                v-model="add_Client_company.countrys"
                class="right20"
                placeholder="国家">
                <el-option
                  v-for="item in countrys_list"
                  :key="item.countrys_id"
                  :label="item.countrys_name"
                  :value="item.countrys_id">
                </el-option>
              </el-select>
              <el-select
                v-model="address_pid"
                class="right20"
                @change="change_pro" placeholder="省份">
                <el-option
                  v-for="item in pro_list"
                  :key="item.address_id"
                  :label="item.address_name"
                  :value="item.address_id">
                </el-option>
              </el-select>

              <el-select
                v-model="add_Client_company.city" placeholder="城市">
                <el-option
                  v-for="item in city_list"
                  :key="item.address_id"
                  :label="item.address_name"
                  :value="item.address_name">
                </el-option>
              </el-select>
            </div>
            <div class="itme">
              <div class="name">公司地址</div>
              <el-input v-model="add_Client_company.address"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司電話</div>
              <el-input v-model="add_Client_company.tel"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司傳真</div>
              <el-input v-model="add_Client_company.fax"></el-input>
            </div>
            <div class="itme">
              <div class="name">公司網址</div>
              <el-input v-model="add_Client_company.website"></el-input>
            </div>
          </div>
          <div class="itme_box" v-for="(itme,index) in contact_person" :key="index">
            <div class="itme">
              <div class="name">聯絡人</div>
              <el-input v-model="itme.customer_liaisons"></el-input>
            </div>
            <div class="itme">
              <div class="name">聯系手機</div>
              <el-input v-model="itme.customer_phone"></el-input>
            </div>
            <div class="itme">
              <div class="name">聯絡人郵箱</div>
              <el-input v-model="itme.customer_email"></el-input>
            </div>
            <div v-if="index === 0"
                 @click="add_contact_person"
                 class="icon">
              <i class="el-icon-plus"></i>
            </div>
            <div v-if="index !== 0"
                 @click="minus_contact_person(index)"
                 class="icon">
              <i class="el-icon-minus"></i>
            </div>
          </div>
          <div class="paymentmethodbut">
            <mt-button @click="retuen_window" type="primary">返回</mt-button>
            <mt-button @click="on_add_Client_company" type="primary">确定</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <div class="conten">
      <ul class="equipment_management" :class="show_search_state?'show_search':''">
        <li class="header_search" :class="show_search_state?'show_search':''">
          <div class="search_input_box">
            <div>
              <el-input size="mini" v-model="key_word" placeholder="名称/手机号码/电话/邮箱"></el-input>
            </div>
            <div>
              <el-button size="mini" @click="onseach" type="success">查詢</el-button>
            </div>
          </div>
          <i class="el-icon-arrow-down" @click="showsearchbox"></i>
        </li>
        <li class="header_list" :class="show_search_state?'show_search':''">
          <div>客戶編號</div>
          <div>公司名称</div>
          <div>联络人</div>
          <div>牙醫名稱</div>
          <div>电话</div>
          <div>手機號碼</div>
          <div>傳真</div>
          <div>電郵地址</div>
          <div>國家</div>
          <div>省分</div>
          <div>城市</div>
          <div>詳細地址</div>
          <div>客戶添加日期</div>
          <div>客戶状态</div>
          <div>最後訂單日期</div>
          <div>訂單總金額</div>
          <div>點數</div>
        </li>
        <li @click="edit(itme.company_id)" v-for="(itme,index) in equipment_list" :key="index">
          <div>{{itme.customer_num}}</div>
          <div>{{itme.company_name[0]}}</div>
          <div>{{itme.customer_liaisons}}</div>
          <div></div>
          <div>{{itme.company_tel[0]}}</div>
          <div>{{itme.customer_phone}}</div>
          <div>{{itme.company_fax[0]}}</div>
          <div>{{itme.customer_email}}</div>
          <div>{{itme.company_countrys}}</div>
          <div>{{itme.company_province}}</div>
          <div>{{itme.company_city}}</div>
          <div>{{itme.company_address.toString()}}</div>
          <div>{{itme.create_time}}</div>
          <div>{{itme.company_ifshow==='1'?'正常':'異常'}}</div>
          <div></div>
          <div></div>
          <div></div>
        </li>
      </ul>
      <div class="add_order_but" @click="show_add_box = true">
        <i class="el-icon-circle-plus-outline"></i>
      </div>
      <div class="bottom_but">
        <el-button type="success" @click="printit">
          PRINT
          <!--<a href="javascript:window.print()" target="_self">PRINT</a>-->
        </el-button>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <!--<el-button v-show="list_class === 0" @click="switch_list(2)" type="success">技工所</el-button>-->
        <!--<el-button v-show="list_class === 2" @click="switch_list(1)" type="success">原列表</el-button>-->
        <!--<el-button v-show="list_class === 1" @click="switch_list(0)" type="success">員工</el-button>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    lis,
    add_customer_company,
    getcountrys,
    getaddress,
    getcompanyedit,
    getcustomer_num,
    getNumber2,
    getNum,
  } from '../../assets/js/api'

  export default {
    name: "orderlist",
    data() {
      return {
        show_search_state: false, //設備列表
        equipment_list: [], //設備列表
        key_word: '',//关键字
        currentPage: 1,//當前頁數
        total: 0,//數據總數
        show_add_box: false,//增加客戶公司窗口
        add_Client_company:{
          type:'add',
          company:'',
          address:'',
          tel:'',
          fax:'',
          website:'',
          // 聯絡人
          customer_liaisons:'',
          customer_phone:'',
          customer_email:'',
          countrys:'',  //国家id
          pro:'',  //省文本  如：广东省
          city:'', //城市文本  如：广州市
          customer_num:'', //客戶編號
          customer_num_main:'', //客戶類型
          customer_num_secondary:'', //客戶類型二級
        },
        contact_person:[
          {
            customer_liaisons:'',
            customer_phone:'',
            customer_email:'',
            customer_id:'',
          }
        ],
        countrys_list:[],//国家列表
        pro_list:[],  //省列表
        city_list:[], //市列表
        address_pid:'',
        customer_type:[], //客戶類型
        customer_type2:[], //客戶類型2
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {
      this.currentPage = Number(this.$route.query.currentPage) || 1

      this.onseach()

      getcountrys().then(data=>{
        this.countrys_list = data.data
      })

      getaddress().then(data=>{
        this.pro_list = data.data
      })

      getcustomer_num().then(data=>{
        if (data.status){
          this.customer_type = data.data
        }
      })
    },
    methods: {
      change_customer_num_main(){
        getNumber2(this.add_Client_company.customer_num_main).then(data=>{
          if (data.status){
            this.customer_type2 = data.data
            this.add_Client_company.customer_num_secondary = this.customer_type2[0].category_remark
            this.change_customer_num_secondary()
          }
        })
      },
      change_customer_num_secondary(){
        getNum(this.add_Client_company.customer_num_main,this.add_Client_company.customer_num_secondary).then(data=>{
          if (data.status){
            this.add_Client_company.customer_num = data.data
          }
        })
      },
      edit(id){
        getcompanyedit(id).then(data=>{
          if (data.status){
            this.add_Client_company.type = 'edit'
            this.add_Client_company.company_id = data.data.company_id
            this.add_Client_company.company = data.data.company_name
            this.add_Client_company.address = data.data.company_address
            this.add_Client_company.tel = data.data.company_tel
            this.add_Client_company.fax = data.data.company_fax
            this.add_Client_company.website = data.data.company_website
            this.add_Client_company.countrys = data.data.company_countrys


            this.add_Client_company.city = data.data.company_city

            this.contact_person = data.data.customer

            this.add_Client_company.customer_num = this.contact_person[0].customer_num
            this.add_Client_company.customer_num_main = this.contact_person[0].customer_num_main
            this.add_Client_company.customer_num_secondary = this.contact_person[0].customer_num_secondary

            this.pro_list.map(item=>{
              if (item.address_name === data.data.company_province){
                this.address_pid = item.address_id
              }
            })
            this.show_add_box = true
          }
          else {
            this.$alert(data.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        })
      },
      retuen_window(){
        this.show_add_box = false
        setTimeout(()=>{
          this.add_Client_company.type = 'add'
          this.add_Client_company.company_id = ''
          this.add_Client_company.company = ''
          this.add_Client_company.address = ''
          this.add_Client_company.tel = ''
          this.add_Client_company.fax = ''
          this.add_Client_company.website = ''
          this.add_Client_company.countrys = ''
          this.add_Client_company.city = ''
          this.add_Client_company.customer_id = ''
          this.add_Client_company.customer_num = ''
          this.add_Client_company.customer_num_main = ''
          this.add_Client_company.customer_num_secondary = ''
          this.address_pid = ''
          this.contact_person = [
            {
              customer_liaisons:'',
              customer_phone:'',
              customer_email:'',
              customer_id:'',
            }
          ]
        },500)
      },
      change_pro(){
        this.pro_list.map(item=>{
          if(item.address_id === this.address_pid){
            this.add_Client_company.pro = item.address_name
          }
        })
        this.add_Client_company.city = ''
        getaddress(this.address_pid).then(data=>{
          this.city_list = data.data
        })
      },
      // 添加客戶公司
      on_add_Client_company(){
        let customer_liaisons = []
        let customer_phone = []
        let customer_email = []
        let customer_id = []
        this.contact_person.map(itme=>{
          customer_liaisons.push(itme.customer_liaisons)
          customer_phone.push(itme.customer_phone)
          customer_email.push(itme.customer_email)
          customer_id.push(itme.customer_id)
        })
        this.add_Client_company.customer_liaisons = customer_liaisons.toString()
        this.add_Client_company.customer_phone = customer_phone.toString()
        this.add_Client_company.customer_email = customer_email.toString()
        this.add_Client_company.customer_id = customer_id.toString()
        add_customer_company(this.add_Client_company).then(data=>{
          this.show_add_box = false
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.msg,
            }).then(() => {
              this.edit_state = false
            });
          }
          else {
            this.$alert(data.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.edit_state = false
              }
            });
          }
          if(data.status){
            this.onseach()
            this.add_Client_company.company = ''
            this.add_Client_company.address = ''
            this.add_Client_company.tel = ''
            this.add_Client_company.fax = ''
            this.add_Client_company.website = ''
            this.contact_person=[
              {
                customer_liaisons:'',
                customer_phone:'',
                customer_email:'',
              }
            ]
          }
        })
      },
      // 增加聯絡人
      add_contact_person(){
        this.contact_person.push({
          customer_liaisons:'',
          customer_phone:'',
          customer_email:'',
        })
      },
      // 刪除聯絡人
      minus_contact_person(index){
        this.contact_person.splice(index,1)
      },
      onseach(){
        let p_data={
          keywork:this.key_word,
          page:this.currentPage,
        }
        lis(p_data).then(data => {
          if (data.status) {
            this.equipment_list = data.data
            this.total = data.totalsize
          }
          else {
            this.equipment_list = []
            this.total = 0
          }
        })
      },
      printit(){
        try{
          print.portrait   =  false    ;//横向打印
        }catch(e){
          alert("不支持此方法");
        }
        window.print();
      },
      showsearchbox() {
        if (this.show_search_state) {
          this.show_search_state = false
        }
        else {
          this.show_search_state = true
        }
      },
      //切換列表
      handleCurrentChange(val) {
        this.currentPage = val
        this.onseach()
      },
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }


  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    .signature_box {
      backgrond: #fff;
      width: 80vw;
      padding-top: 10%;
      text-align: center;
      @media (min-width: @screen-xs-max) {
        width: 40vw;
      }
      .itme_box{
        margin-bottom: 20px;
        position: relative;
        .itme{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;
          >.name{
            width: 30%;
            text-align: left;
            flex-shrink: 0;
          }
          .customer_num{
            width: 28%;
          }
          .right20{
            margin-right: 10px;
          }
        }
        .icon{
          position: absolute;
          right: -30px;
          bottom: 10px;
          cursor: pointer;
        }
      }
      .paymentmethodbut {
        display: flex;
        justify-items: center;
        justify-content: center;
        .mint-button {
          /*margin-right: 20px;*/
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .add_subsidiaries_box{
      height: 90vh;
      overflow: auto;
      .signature_box {
        padding: 30px 50px;
        height: auto;
      }
    }
    .conten {
      margin-top: 52px;
      ul.equipment_management  {
       background: #fff;
        padding-bottom: 1px;
        /*min-height: 96vh;*/
        margin-top: 52px;
        padding-top: 104px;
        transition: all 0.5s;
        &.show_search{
          padding-top: 140px;
        }
        li {
          background-color: #f2f2f2;
          margin: 10px 0;
          width: 96%;
          padding: 20px 2%;
          display: flex;
          /*flex-direction: column;*/
          align-items: center;
          justify-content: space-around;
          > div {
            width: 12%;
            min-width: 5%;
            text-align: center;
            cursor: pointer;
            word-wrap: break-word;
            .modify_tag{
              border-bottom: 1px #000 dotted;
              display: inline-block;
              padding: 5px;
              min-width: 50%;
            }
          }
          &.white {
            background: white;
          }
          &.header_list {
            position: fixed;
            background-color: #57c5f7;
            padding: 20px 2%;
            margin: 0;
            z-index: 9;
            top: 80px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            &.show_search{
              top: 112px;
            }
            > div {
              font-size: 15px;
              font-weight: bold;
            }
          }
          &.header_search {
            width: 100%;
            position: fixed;
            flex-direction: column;
            justify-items: center;
            background-color: #327594;
            margin: 0;
            padding: 10px 0;
            z-index: 9;
            top: 52px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            height: 10px;
            .search_input_box{
              display: none;
              width: 90%;
              cursor: auto;
              >div{
                margin: 0 20px;
              }
            }
            &.show_search{
              height: 50px;
              .search_input_box{
                display: flex;
                align-items: center;
                justify-content: center;
              }
              >i{
                transform: rotate(180deg);
              }
            }
            > i {
              transition: all 0.5s;
              font-size: 20px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
      .bottom_but {
        position: fixed;
        width: 96%;
        padding: 0 2%;
        display: flex;
        justify-content: space-between;
        bottom: 30px;
        a{
          color: #fff;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/customer.vue